<template>
  <v-row class="body">
    <v-col class="pa-13" align="center" cols="12" md="5" xl="3" lg="4" sm="12" xs="12">
      <v-form>
        <div class="mb-12">
          <img style="width: 6rem" :src="require('../../public/logo.png')" alt="" />
        </div>
        <v-card flat class="card mt-5 pa-6">
          <v-card-title align="start" class="Login-title pa-0 ma-0 pb-3"> Send OTP</v-card-title>
          <v-error class="pb-0 pt-3" v-if="userNotFount"> User not found in synergy </v-error>
          <v-card-text class="pa-0 mt-2 pt-2">
            <v-col class="pa-0 ma-0">
              <v-col align="start" class="pa-0 ma-0 lable">Enter your number</v-col>
              <TextFieldComponent
                density="compact"
                @click:append-inner="showPassword = !showPassword"
                placeholder="mobile no:"
                :rules="mobileRule"
                v-model="mobile"
                variant="outlined"
                v-bind:type="[showPassword ? 'text' : 'password']"
                :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              ></TextFieldComponent>
            </v-col>
          </v-card-text>
          <v-col align="start" class="pa-0 ma-0 mb-4 mt-2 forget">Resent OTP ?</v-col>
          <v-card-action>
            <v-col class="pa-0 pt-2" cols="12">
              <v-btn
                color="#0068B3"
                block
                size="large"
                :loading="loading"
                class="text-none log-btn text-white mb-4"
                @click="sendEmail()"
                >Send OTP</v-btn
              >
            </v-col>
          </v-card-action>
        </v-card>
        <v-col class="log-text mt-4"
          >If you have trouble signing in please contact administrator</v-col
        >
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import TextFieldComponent from "./TextFieldComponent.vue";
// import userService from "../api/service/UserService.js"
import ResetPasswordService from "@/api/service/ResetPasswordService";
export default {
  components: {
    TextFieldComponent,
  },
  data() {
    return {
      userNotFount: false,

      loading: false,
      showPassword: false,
      mobileRule: [(value) => !!value || "Password is Required."],
      mobile: null,
      host: "",
      rules: {
        emailValidation: (value) => !!value || "Email is Required.",
        useremail: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },
  methods: {
    async sendEmail() {
      try {
        this.loading = true;
        let data = {
          host: window.location.origin,
          email: this.email,
          appId: localStorage.getItem("APP_ID"),
          redirectUrl: localStorage.getItem("REDIRECT_URL"),
        };
        localStorage.setItem("PASSWORD_DATA", JSON.stringify(data));
        let response = await ResetPasswordService.forgotPassword(data);
        console.log(response, "hhhhhhhhh");
        if (response.message == "User not found in firebase") {
          this.userNotFount = true;
          this.loading = false;
        } else {
          this.$router.push({
            path: "/checkemail",
            query: { email: this.email, host: window.location.origin },
          });
        }
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
  },
};
</script>

<style>
.back {
  cursor: pointer;
}
.back:hover {
  color: rgb(104, 104, 246);
  cursor: pointer;
}
</style>
